import React from 'react';
import { useParams, Link } from 'react-router-dom';
import CourseCard from '../components/CourseCard';
import '../styles/courses.css';

const Courses = () => {
  const courses = [
    // {
    //   id: 'course-registration',
    //   title: 'Course Registration',
    //   originalPrice: '₹9999.00',
    //   price: '₹5100.00',
    //   features: [
    //     'Access to all course materials',
    //     'Expert instructor guidance',
    //     'Hands-on practice exercises',
    //     'Certificate of completion'
    //   ],
    //   isLimitedOffer: true,
    //   videoUrl: 'https://www.youtube.com/shorts/w2-rfIbLyCY',
    //   thumbnail: 'https://images.unsplash.com/photo-1749947213438-47476d0cc79e?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw1fHx8ZW58MHx8fHx8',
    //   duration: '4 Months'
    // },
    {
      id: 'salesforce-ai-bootcamp',
      title: 'Salesforce AI - APP Development Bootcamp',
      originalPrice: '₹10000.00',
      price: '₹499.00',
      features: [
        'Build AI-powered Salesforce apps',
        'Einstein AI integration',
        'Real-world projects',
        'Certification guidance'
      ],
      isBestseller: true,
      isLimitedOffer: true,
      videoUrl: 'https://youtube.com/embed/salesforce-ai',
      thumbnail: '/images/salesforce-ai-thumb.jpg',
      duration: '5 Days',
    },
    {
      id: 'salesforce-business-analyst',
      title: 'Salesforce Business Analyst',
      originalPrice: '₹50000.00',
      price: '₹45000.00',
      features: [
        'Business requirements analysis',
        'Process mapping techniques',
        'Stakeholder management',
        'Salesforce configuration'
      ],
      imageUrl: '/images/business-analyst.jpg',
      duration: '3 months + projects',
      category: ['Salesforce', 'Business Analysis']
    },
    {
      id: 'salesforce-lwc-developer',
      title: 'Salesforce LWC Developer',
      originalPrice: '₹25000.00',
      price: '₹19000.00',
      features: [
        'Lightning Web Components',
        'Modern JavaScript',
        'Salesforce DX',
        'Performance optimization'
      ],
      videoUrl: 'https://youtube.com/embed/lwc-developer',
      thumbnail: '/images/lwc-thumb.jpg',
      duration: '45 days',
      category: ['Salesforce', 'Development']
    },
    // {
    //   id: 'career-guidance-general',
    //   title: 'Career Guidance On What to Choose',
    //   originalPrice: '₹499.00',
    //   price: '₹299.00',
    //   features: [
    //     'Personalized career assessment',
    //     'Industry trends analysis',
    //     'Skill gap evaluation',
    //     'Roadmap creation'
    //   ],
    //   isBestseller: true,
    //   isSession: true,
    //   imageUrl: '/images/career-guidance.jpg',
    //   duration: '30 min session'
    // },
    // {
    //   id: 'career-guidance-salesforce',
    //   title: 'Career Guidance On Salesforce',
    //   originalPrice: '₹499.00',
    //   price: '₹299.00',
    //   features: [
    //     'Salesforce career paths',
    //     'Certification roadmap',
    //     'Salary benchmarks',
    //     'Interview preparation'
    //   ],
    //   isBestseller: true,
    //   isSession: true,
    //   imageUrl: '/images/salesforce-career.jpg',
    //   duration: '30 min session',
    //   category: ['Salesforce', 'Career']
    // },
    {
      id: 'salesforce-platform-developer',
      title: 'Salesforce Platform Developer',
      originalPrice: '₹49999.00',
      price: '₹44999.00',
      features: [
        'Advanced Apex programming',
        'Integration patterns',
        'Security best practices',
        'Complex business logic'
      ],
      videoUrl: 'https://youtube.com/embed/platform-developer',
      thumbnail: '/images/platform-dev-thumb.jpg',
      duration: '4 months including projects',
      category: ['Salesforce', 'Development']
    },
    {
      id: 'advanced-apex-developer',
      title: 'Advanced Apex Developer',
      originalPrice: '₹24999.00',
      price: '₹22999.00',
      features: [
        'Advanced Apex techniques',
        'Asynchronous processing',
        'Custom metadata types',
        'Unit testing best practices',
        'Integration with external systems',
        'platform events'
      ],
      isBestseller: true,
      imageUrl: '/images/advanced-apex-course.jpg',
      duration: '3 months + projects',
      category: ['Salesforce', 'Certification']
    },
    // {
    //   id: 'salesforce-admin-bootcamp',
    //   title: 'Salesforce Admin Bootcamp',
    //   originalPrice: '₹35000.00',
    //   price: '₹29999.00',
    //   features: [
    //     'Administration essentials',
    //     'Security & access control',
    //     'Data management',
    //     'Automation basics'
    //   ],
    //   videoUrl: 'https://youtube.com/embed/admin-bootcamp',
    //   thumbnail: '/images/admin-thumb.jpg',
    //   duration: '6 weeks',
    //   category: ['Salesforce', 'Administration']
    // },
    // {
    //   id: 'salesforce-cpq-specialist',
    //   title: 'Salesforce CPQ Specialist',
    //   originalPrice: '₹60000.00',
    //   price: '₹55000.00',
    //   features: [
    //     'Configure Price Quote',
    //     'Product rules',
    //     'Pricing methodologies',
    //     'Quote templates'
    //   ],
    //   imageUrl: '/images/cpq-course.jpg',
    //   duration: '2 months',
    //   category: ['Salesforce', 'CPQ']
    // }
  ];

  return (
    <div className="courses-page">
      <div className="container">
        <h1>Our Comprehensive Course Catalog</h1>
        <p></p>
        <div className="courses-grid">
          {courses.map(course => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;